// extracted by mini-css-extract-plugin
export default {"coreValues":"CoreValues_coreValues__W9Lwa","section":"CoreValues_section__cyFO1","twoColumn":"CoreValues_twoColumn__o1LUe"};